import { render, staticRenderFns } from "./productApprove-create.vue?vue&type=template&id=62500ec1&scoped=true"
import script from "./productApprove-create.vue?vue&type=script&lang=js"
export * from "./productApprove-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62500ec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62500ec1')) {
      api.createRecord('62500ec1', component.options)
    } else {
      api.reload('62500ec1', component.options)
    }
    module.hot.accept("./productApprove-create.vue?vue&type=template&id=62500ec1&scoped=true", function () {
      api.rerender('62500ec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/productApprove-management/productApprove-create.vue"
export default component.exports